import { ButtonBase, CircularProgress } from '@mui/material'
import { COLORS } from '@repo/design-system/index'
import { QIcon_mic_default } from '@repo/icons/index'
import { useEffect, useState } from 'react'
import { n_ai_speaking } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../LoadingSpinner'

const RecordingComponent = ({ onClickStart, loading, isSessionClosing, handleSessionSummary, showNudge, helper }) => {
  const { t } = useTranslation()
  const [micTextIndex, setMicTextIndex] = useState(0)
  const micTextArray = [
    t(n_ai_speaking.ai_session.msg1),
    t(n_ai_speaking.ai_session.msg2),
    t(n_ai_speaking.ai_session.msg3),
  ]
  const [fixMicTextForTenSeconds, setFixMicTextForTenSeconds] = useState(true)

  useEffect(() => {
    let interval

    if (fixMicTextForTenSeconds) {
      setTimeout(() => {
        setFixMicTextForTenSeconds(false)
      }, 10000)
    } else {
      interval = setInterval(() => {
        const nextIndex = (micTextIndex + 1) % micTextArray.length
        setMicTextIndex(nextIndex)
      }, 3000)
    }

    return () => clearInterval(interval)
  }, [micTextIndex, fixMicTextForTenSeconds])

  return (
    <div className="flex flex-col items-center justify-center" style={{}}>
      <div className="bg-white text-center flex items-center justify-center h-[48px]">
        {!loading && (
          <div className="items-center justify-center Body2-14Md text-gray-500 flex">
            {helper ?? micTextArray[micTextIndex]}
          </div>
        )}
      </div>
      {loading ? (
        <div className="mt-[12px] h-[64px] flex items-center justify-center">
          <LoadingSpinner lg show primary />
        </div>
      ) : (
        <>
          <div
            className="mt-[12px] flex flex-col items-center justify-center bg-purple-500 
            rounded-[100px] w-[64px] h-[64px] cursor-pointer hover:bg-purple-600 active:bg-purple-700"
            onClick={onClickStart}
          >
            <QIcon_mic_default width={32} height={32} className="bg-contain" color={COLORS.WHITE} />
          </div>
        </>
      )}

      {showNudge && (
        <ButtonBase
          style={{
            border: '1px solid gray',
            right: 16,
            padding: 12,
            borderRadius: 24,
            position: 'absolute',
            top: 'calc(50% + 20px)',
            transform: 'translateY(-50%)',
          }}
          className="rounded-[100px] border-1 border-gray-200 px-[16px] py-[12px]
          "
          disabled={isSessionClosing}
          onClick={handleSessionSummary}
        >
          <div>
            <div className="Body2-14Md text-gray-500">
              {t(n_ai_speaking.ai_session.btn_end)} {isSessionClosing && <CircularProgress size={10} />}
            </div>
          </div>
        </ButtonBase>
      )}
    </div>
  )
}

export default RecordingComponent
